module.exports = __webpack_public_path__ + "img/lightFI.418e9664.png";